import React from 'react';
// components
import Form from '../../../components/Form/Form';
import FieldError from '../../../components/Form/FieldError';
import Input from '../../../components/Input/Input';
import TextArea from '../../../components/TextArea/TextArea';
import Button from '../../../components/Button/Button';
import FormErrors from '../../../components/Form/FormErrors';
import { toast } from 'react-toastify';
// utils
import { withFormik } from 'formik';
import * as yup from 'yup';
import api from '../../../utils/api';
import { responseErrors } from '../../../utils/response';
// styles
import styles from './ContactUs.mod.css';

export const ContactUS = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit
}) => (
  <div className={styles.container}>
    <h2 className="text-center">Contact Us</h2>
    <FormErrors errors={errors} />
    <Form
      horizontal
      centered
      className={styles.container}
      onSubmit={handleSubmit}
    >
      <div className="form-control mt-50">
        <label className="label" htmlFor="name">
          My message is about
        </label>
        <div className="field-wrapper">
          <Input
            className={styles.inputs}
            name="subject"
            placeholder="Your subject matter"
            value={values.subject}
            onChange={handleChange}
            onBlur={handleBlur}
            invalid={errors.subject && touched.subject}
          />
          <FieldError error={errors.subject} touched={touched.subject} />
        </div>
      </div>
      <div className="form-control">
        <label className="label" htmlFor="name">
          Message
        </label>
        <div className="field-wrapper">
          <TextArea
            rows="5"
            className={styles.inputs}
            name="message"
            placeholder="Your question"
            value={values.message}
            onChange={handleChange}
            onBlur={handleBlur}
            invalid={errors.message && touched.message}
          />
          <FieldError error={errors.message} touched={touched.message} />
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        <Button
          type="submit"
          primary
          isLoading={isSubmitting}
          disabled={isSubmitting}
        >
          Send
        </Button>
      </div>
    </Form>
  </div>
);

export default withFormik({
  mapPropsToValues: () => ({
    subject: '',
    message: ''
  }),
  validationSchema: yup.object().shape({
    subject: yup
      .string()
      .min(3, 'The subject must be longer')
      .required('The subject is required!'),
    message: yup
      .string()
      .min(10, 'The message must be longer')
      .required('The message is required!')
  }),
  handleSubmit: (
    { subject, message },
    { setSubmitting, setErrors, resetForm }
  ) => {
    api
      .contactUs({ subject, message })
      .then(() => {
        toast.success('Your question was successfully sent.');
        resetForm();
        setSubmitting(false);
      })
      .catch(response => {
        setErrors(responseErrors(response));
        setSubmitting(false);
      });
  },
  displayName: 'ContactUS'
})(ContactUS);



// WEBPACK FOOTER //
// ./src/containers/Help/components/ContactUs.jsx